import { useLoaders } from '@/shared';
import { useFetchUbicacionProductosEnabled } from '@/shared/actions/erp';
import { AlertSeverityEnum, Flota } from '@/shared/interfaces';
import {
  CategoryProducCodeEnum,
  IUbicacionProducto,
} from '@/shared/interfaces/erp/inventario';
import { MaterialesKey, useMaterialesUtilizadosStore } from '@/store/erp';
import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';

type UseEquiposDisponiblesProps = {
  //ordenTrabajo: OrdenTrabajo;
  id:string
  flota_data: Flota
};

export const useEquiposDisponiblesFlotaOT = ({
  //ordenTrabajo,
  id,
  flota_data
}: UseEquiposDisponiblesProps) => {
  ///* global state ==========================
  const setAlert = useUiStore(s => s.setAlert);
  const setItemsInStorage = useMaterialesUtilizadosStore(
    s => s.setSelectedItems
  );

  ///* fetch data ==========================
  const {
    data: itemsDisponiblesPaging,
    isLoading: isLoadingItemsDisponibles,
    isRefetching: isRefetchingItemsDisponibles,
  } = useFetchUbicacionProductosEnabled({
    //enabled: !!ordenTrabajo?.id_orden_trabajo,
    enabled: !!id,
    params: {
      estado: true,
      ubicacion: flota_data?.ubicacion || "no-location",
      page_size: 900,
    },
  });

  ///* effects ==========================
  // set up equipos/materiales disponibles/asignados from Ubicacion
  useEffect(() => {
    if (
      !id ||
      isLoadingItemsDisponibles ||
      isRefetchingItemsDisponibles
    )
      return;

    ///* validate stock in ubicacion/flota
    const items = itemsDisponiblesPaging?.data?.data || []
        
    if (!items.length) {
      setAlert(
        true,
        'No cuenta con items en la flota',
        AlertSeverityEnum.warning
      );
    }

    ///* EQUIPOS disponibles -------------------
    const equiposDisponibles = items.filter(
      (item: IUbicacionProducto) =>
        item?.producto_data?.categoria_producto ===
        CategoryProducCodeEnum.EQUIPOS
    );

    if (!equiposDisponibles?.length) {
      setAlert(
        true,
        'No cuenta con equipos disponibles en la flota',
        AlertSeverityEnum.error
      );
    }
    setItemsInStorage(equiposDisponibles, MaterialesKey.equiposDisponibles);

    ///* MATERIALES disponibles -------------------
    const materialesDisponibles = items.filter(
      (item: IUbicacionProducto) =>
        item?.producto_data?.categoria_producto ===
        CategoryProducCodeEnum.MATERIALES
    );
    if (!materialesDisponibles?.length) {
      setAlert(
        true,
        'No cuenta con materiales disponibles en la flota',
        AlertSeverityEnum.error
      );
    }
    setItemsInStorage(
      materialesDisponibles,
      MaterialesKey.materialesDisponibles
    );
  }, [id, isLoadingItemsDisponibles, isRefetchingItemsDisponibles]);

  useLoaders(isLoadingItemsDisponibles || isRefetchingItemsDisponibles);

  return {
    isLoadingItemsDisponibles,
    isRefetchingItemsDisponibles,
  };
};
